import emailjs from '@emailjs/browser';

const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

/**
 * Submit a consultancy request form.
 *
 * Currently sends via EmailJS → olajuwonlawal2012@gmail.com.
 * To swap for a real backend, replace the emailjs.send() call with:
 *   const res = await fetch('/api/contact', { method: 'POST', body: JSON.stringify(data), ... });
 *   if (!res.ok) throw new Error(await res.text());
 *
 * @param {{ name: string, email: string, phone: string, org: string, projectType: string, message: string }} data
 * @returns {Promise<{ success: true }>}
 */
export async function submitContactForm({ name, email, phone, org, projectType, message }) {
  // Simulate network round-trip feel while EmailJS processes
  await new Promise((resolve) => setTimeout(resolve, 600));

  await emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    {
      from_name:    name,
      from_email:   email,
      phone:        phone || 'Not provided',
      organization: org   || 'Not specified',
      project_type: projectType,
      message,
    },
    PUBLIC_KEY,
  );

  return { success: true };
}
